import { GetterTree } from 'vuex'

import { RootState } from '@/store/types'

import { UserState } from './types'

const getters: GetterTree<UserState, RootState> = {
  userDetails: state => state.userDetails,

  name: state => state.userDetails && state.userDetails.name,

  email: state => {
    if (
      state.userDetails?.email?.startsWith('playground+fakeSR') &&
      state.userDetails?.email?.endsWith('@careship.de')
    ) {
      return ''
    }

    return state.userDetails?.email || ''
  },

  phoneNumber: state => state.userDetails && state.userDetails.phone_number,

  salutation: state =>
    (state.userDetails && state.userDetails.salutation) || '',

  gender: state => state.userDetails && state.userDetails.gender,

  customerId: state => state.userDetails && state.userDetails.customer_id,

  fullName: state =>
    state.userDetails &&
    state.userDetails.name &&
    `${state.userDetails.name.first_name} ${state.userDetails.name.last_name}`,

  lastName: state =>
    (state.userDetails &&
      state.userDetails.name &&
      state.userDetails.name.last_name) ||
    '',

  isEmailPendingVerification: state => state.isEmailPendingVerification,

  serviceRequest: state => state.serviceRequest,

  contract: state => state.contract,

  shouldDisplaySetupPasswordDialog: state =>
    !state.isEmailPendingVerification &&
    !state.isPasswordSet &&
    !state.isOneTimeLoginSession,
}

export default getters
